import { render, staticRenderFns } from "./comp-4.vue?vue&type=template&id=6482e95a"
import script from "./comp-4.vue?vue&type=script&lang=js"
export * from "./comp-4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports